import {initDialog, toggleDialog, closeDialog, modalVisible} from './_dialog'

export let movingToContent = false;

var firstRun = true,
	swipeDisabled = true,
	animationFinished = false;

export function introAnimation() {
	(function ($) {
		
		'use strict';

		var $body = $('html, body'),
		speed = 2800;
		animationFinished = false;

		closeDialog();

		if (firstRun) {
			firstRun = false;
			$('.jsMain').prepend('<div class="intro l-intro-wrapper jsIntro"><div class="intro-logo intro__logo intro__logo--1 jsIntroLogo1"><img class="intro-logo__svg" src="/resources/themes/a2ei/img/A2EI_logo_horizontal-1.svg"></div><div class="intro-logo intro__logo intro__logo--2 jsIntroLogo2"><img class="intro-logo__svg" src="/resources/themes/a2ei/img/A2EI_logo_horizontal-2.svg"></div><div class="intro-arrow jsIntroArrow"><img class="intro-arrow__svg" src="/resources/themes/a2ei/img/A2EI_arrow_2.svg"></div></div>');
		} 

		$('.jsIntroArrow').addClass('is-not-loaded');
		$('.jsIntroLogo1, .jsIntroLogo2').stop(true).fadeTo(0, 0, function() {});
		$('.jsPageTitle').stop(true).fadeTo(300, 0, function() {});

		$('.jsIntroLogo1').animate({
			opacity: 1},
			speed, function() {});

		$('.jsIntroLogo2').delay(1500).animate({
			opacity: 1},
			2000, function() {
				animationFinished = true;
				setTimeout(function () {
					$('.jsIntroArrow').removeClass('is-not-loaded');
				}, 3000);
			});

		$.browserSwipe({
			up: function(){
				moveScrollBack();
			},
			down: function(){
				moveScroll();
			}
		});

		$('.jsIntroLogo2, .jsIntroArrow').on('touchmove click',function(){
			moveScroll();
		});

		var moveScroll = function(){

			if (swipeDisabled && animationFinished && !modalVisible) {
				swipeDisabled = false;
				animationFinished = false;
				movingToContent = true;
				$body.removeClass('is-fixed');
				$('.l-intro-wrapper').addClass('is-hidden');
				$('.jsLogo').stop(true).fadeTo(300, 1, function() {});
				$('.jsPageTitle').stop(true).fadeTo(300, 1, function() {});
				$('.jsIntroArrow').addClass('is-not-loaded');
				setTimeout(function () {
					movingToContent = false;
				}, 800);
			}
		}

		var moveScrollBack = function(){
			if (scrollPosTop && !modalVisible) {
				$body.addClass('is-fixed');
				$('.l-intro-wrapper').removeClass('is-hidden');
				swipeDisabled = true;
				animationFinished = true;
				$('.jsIntroArrow').addClass('is-not-loaded');
				$('.jsLogo').stop(true).fadeTo(300, 0, function() {$('.jsLogo').hide()});
				$('.jsPageTitle').stop(true).fadeTo(300, 0, function() {$('.jsPageTitle').hide()});
			}
		}


	})(jQuery);
}
